import React from 'react';
import styled from 'styled-components';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import SettingCard, { SettingInfoBox, SettingInfoLabel, SettingInfoValue, CardFooter, SaveButton } from './SettingCard';

const DescriptionBox = styled.div`
    margin-top: 16px;
    padding: 16px 18px;
    background: #f8f9fb;
    border: 1px solid #e0e4ea;
    border-radius: 12px;
    font-size: 0.9rem;
    color: #868e96;
    line-height: 1.7;
`;

// 바코드 스캔모드: 0 회원 스캐너(기본) / 1 미사용 / 2 출석기
const AdminClubBarcode = ({ selectClubInfo, setBarcodeMode, setChangeBarcodeModeInfo }) => {
    const onChangeBarcodeMode = (e) => {
        setBarcodeMode(parseInt(e.target.value));
    };
    return selectClubInfo ? (
        <SettingCard title="바코드 스캔모드">
            <SettingInfoBox>
                <SettingInfoLabel>모드</SettingInfoLabel>
                <SettingInfoValue>
                    <RadioGroup
                        aria-label="barcodeMode"
                        name="barcodeMode"
                        value={Number(selectClubInfo.barcodeMode) || 0}
                        onChange={onChangeBarcodeMode}
                        row={true}
                    >
                        <FormControlLabel value={0} control={<Radio color="primary" />} label="회원 스캐너" />
                        <FormControlLabel value={2} control={<Radio color="primary" />} label="출석기" />
                        <FormControlLabel value={1} control={<Radio color="primary" />} label="미사용" />
                    </RadioGroup>
                </SettingInfoValue>
            </SettingInfoBox>
            <DescriptionBox>
                · 회원 스캐너(기본): 회원 비상용 QR을 스캔하면 회원관리 화면이 열립니다.
                <br />
                · 출석기: 스캔 시 출석 처리 + 회원·출석 정보를 잠시 보여줍니다.
                <br />· 미사용: 바코드 스캔을 사용하지 않습니다.
            </DescriptionBox>
            <CardFooter>
                <SaveButton active={selectClubInfo.isBarcodeModeEdit} onClick={() => setChangeBarcodeModeInfo()}>
                    수정하기
                </SaveButton>
            </CardFooter>
        </SettingCard>
    ) : null;
};

export default React.memo(AdminClubBarcode);
